export function formatTime(
  timestamp: string,
  { isUtc = false, onlyHours = false } = {}
) {
  const time = new Date(timestamp);
  const displayOptions: { [key: string]: string | boolean } = {
    hour: "numeric",
    hour12: true,
    minute: "numeric",
  };

  if (isUtc) {
    displayOptions.timeZone = "UTC";
  }

  const displayTime = time
    .toLocaleString("en-US", displayOptions)
    .toLowerCase();

  if (onlyHours) {
    return displayTime.replace(":00", "").replace(" ", "");
  } else {
    return displayTime;
  }
}

export const timeZoneDisplayMapping: { [key: string]: string } = {
  ADT: "AT",
  AST: "AT",
  CDT: "CT",
  CST: "CT",
  EDT: "ET",
  EST: "ET",
  MDT: "MT",
  MST: "MT",
  PDT: "PT",
  PST: "PT",
};

export function weekdayName(dayIndex: number): string {
  return [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ][dayIndex];
}
